export default "__VITE_ASSET__52392542__"